/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Suggest_LabelInputs */

const en_us2_community_suggest_label = /** @type {(inputs: Community_Suggest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your idea`)
};

const pt_br2_community_suggest_label = /** @type {(inputs: Community_Suggest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua ideia`)
};

const es_419_community_suggest_label = /** @type {(inputs: Community_Suggest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu idea`)
};

const pt_pt2_community_suggest_label = /** @type {(inputs: Community_Suggest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua ideia`)
};

const fr_fr2_community_suggest_label = /** @type {(inputs: Community_Suggest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton idée`)
};

const de_de2_community_suggest_label = /** @type {(inputs: Community_Suggest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Idee`)
};

const it_it2_community_suggest_label = /** @type {(inputs: Community_Suggest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua idea`)
};

/**
* | output |
* | --- |
* | "Your idea" |
*
* @param {Community_Suggest_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_suggest_label = /** @type {((inputs?: Community_Suggest_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Suggest_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_suggest_label(inputs)
	if (locale === "es-419") return es_419_community_suggest_label(inputs)
	if (locale === "pt-PT") return pt_pt2_community_suggest_label(inputs)
	if (locale === "fr-FR") return fr_fr2_community_suggest_label(inputs)
	if (locale === "de-DE") return de_de2_community_suggest_label(inputs)
	if (locale === "it-IT") return it_it2_community_suggest_label(inputs)
	return en_us2_community_suggest_label(inputs)
});
export { community_suggest_label as "community.suggest_label" }